/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { requestOneOffEN } from '../service';

function useOneOffENMutation(
    propertyId: number,
    opts?: {
        onSuccess?: () => void;
        onError?: (error: Error) => void;
    }
) {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: (data: { serviceIds: string; noticeId: number }) =>
            requestOneOffEN(propertyId, data.serviceIds, data.noticeId),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['property', propertyId],
            });

            void queryClient.invalidateQueries({
                queryKey: ['notices'],
            });

            if (opts?.onSuccess != null) {
                opts.onSuccess();
            }
        },
        onError: (error) => {
            if (opts?.onError != null) {
                opts.onError(error);
            }
        },
    });

    return query;
}

export { useOneOffENMutation };
